import type { Rule } from 'antd/es/form';
import { t } from 'i18next';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const validateMobileNumber = (_: Rule, value: string): Promise<void> => {
  if (!value) return Promise.resolve();

  const phoneNumber = parsePhoneNumberFromString(value, 'RO');

  if (phoneNumber && phoneNumber.isValid()) {
    return Promise.resolve();
  }

  return Promise.reject(new Error(t('validator.phoneError')));
};
